import {Box, Card, CardContent, Typography} from '@mui/material';
import React from 'react';
import {trackInsightException} from '@app/utils/applicationInsight';

export class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error: any) {
    return {hasError: true, error};
  }

  componentDidCatch(error: any, errorInfo: any) {
    trackInsightException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          alignSelf="center"
          minHeight="100vh"
        >
          <Card sx={{maxWidth: 275}}>
            <CardContent>
              <Typography
                sx={{fontSize: 14}}
                color="text.secondary"
                gutterBottom
              >
                Something went wrong!
              </Typography>
            </CardContent>
          </Card>
        </Box>
      );
    }
    return this.props.children;
  }
}
